/* eslint-disable key-spacing */
import { hsl } from '../../../utils/svgs'

export default {
    fill: {
        chicleShadow:   hsl(0, 3, 32, 0.7),
        chicle:         hsl(60, 3, 92),

        logoShadow:     hsl(60, 18, 37),
        logo:           hsl(60, 23, 72),
    },
}
